export default "__VITE_ASSET__DCI$1xqn__"